import { createSlice } from "@reduxjs/toolkit";
import {
  AllTestimonialsThunk,
  GetSingleTestimonialsThunk,
  AddTestimonialsThunk,
  UpdateTestimonialsThunk,
  DeleteTestimonialsThunk,
} from "./thunk";

const initialState = {
  testimonials: [],
  singleTestimonial: null,
  loading: false,
  error: null,
  successMessage: null,
};

const testimonialsSlice = createSlice({
  name: "testimonials",
  initialState,
  reducers: {
    clearTestimonialsState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // -------------------- ALL TESTIMONIALS --------------------
      .addCase(AllTestimonialsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllTestimonialsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = action.payload?.data || [];
      })
      .addCase(AllTestimonialsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- SINGLE TESTIMONIAL --------------------
      .addCase(GetSingleTestimonialsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleTestimonialsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleTestimonial = action.payload?.data || null;
      })
      .addCase(GetSingleTestimonialsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- ADD TESTIMONIAL --------------------
      .addCase(AddTestimonialsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddTestimonialsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = "Testimonial added successfully!";
      })
      .addCase(AddTestimonialsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- UPDATE TESTIMONIAL --------------------
      .addCase(UpdateTestimonialsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(UpdateTestimonialsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = "Testimonial updated successfully!";
      })
      .addCase(UpdateTestimonialsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- DELETE TESTIMONIAL --------------------
      .addCase(DeleteTestimonialsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(DeleteTestimonialsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = state.testimonials.filter(
          (item) => item.uuid !== action.payload.uuid
        );
        state.successMessage = "Testimonial deleted successfully!";
      })
      .addCase(DeleteTestimonialsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTestimonialsState } = testimonialsSlice.actions;
export default testimonialsSlice.reducer;
